import React from "react";
import { ReactComponent as HomeHeroEllipsGroupSvg } from "../../assets/landingPages/homePage/homeHeroEllipsGroup.svg";
import { ReactComponent as StarVectorSvg } from "../../assets/landingPages/homePage/starShape.svg";
import { ReactComponent as StarVectorSvgDark } from "../../assets/landingPages/homePage/starShapeDark.svg";
import WaitingUserPageImage from "../../assets/landingPages/WaitingUserPageImage.webp";
import useLocales from "../../hooks/useLocales";
import { useNavigate } from "react-router-dom";
import { useStateContext } from "../../contexts/ThemeContext";
import { useEffect } from "react";
import { useForm } from "react-hook-form";
import httpRequest from "../../axios/index";
import toast from "react-hot-toast";
import axios from "axios";
import { useSelector } from "react-redux";
const baseUrl = process.env.REACT_APP_API_URL;

const WaitingListUSer = () => {
  const { darkMode } = useSelector((state) => state.theme);
  const { translate } = useLocales();
  const navigate = useNavigate();
  const handlenavigate = () => {
    navigate("/auth/signUp");
  };

  const inputClasses =
    "focus:outline-none text-heading_color placeholder:text-heading_color xsmm:text-small1   sm:text-custom_h3r w-full lg:w-full";
  const inputErrorClasses =
    "border-state_color_error placeholder:text-state_color_error";
  const inputNoErrorClasses = "";
  // "border-light_bg_v2 focus:placeholder:text-heading_color focus:border-font_light_color";

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ mode: "onChange" });

  const SubmitHandler = async (data) => {
    try {
      const payload = {
        email: data?.email,
      };
      const path = "/api/user/joinWaitingUser";
      const url = baseUrl + path;

      const response = await httpRequest.post(url, payload);
      const result = response?.data?.message;
      const status = response?.data?.status;
      if (status === "success") {
        toast.success(result);
      }
      reset();
    } catch (error) {
      if (error?.response?.data?.status === "failed") {
        toast.error(error?.response?.data?.message);
      } else {
        toast.error("Something went wrong");
      }
    }
  };

  return (
    <>
      <section
        className={`flex  bg-[#fbf7f7] dark:bg-dark-primary -mt-[93px] pt-[93px] items-center justify-center relative`}
      >
        <div className="absolute bottom-0 right-0 ">
          <HomeHeroEllipsGroupSvg className="h-[16rem] w-auto max-h-[16rem] sm:max-h-[493px] md:max-h-[350px] xl:max-h-[470px] sm:h-auto" />
        </div>
        <div className="absolute hidden xl:block lg:left-6 xl:left-20 lg:top-16 xl:top-40">
          {darkMode ? (
            <StarVectorSvgDark className="lg:h-10 xl:h-14" />
          ) : (
            <StarVectorSvg className="lg:h-10 xl:h-14" />
          )}
        </div>
        <div className="2xl:max-w-screen-xl xl:max-w-screen-lg">
          <div className="">
            <div
              className={`px-3  sm:px-9 flex h-full flex-col lg:flex-row gap-12 sm:gap-16 lg:gap-6 items-center lg:pt-14 lg:py-16 xl:pt-16 xl:py-20 2xl:pt-14 2xl:py-24 pt-[60px] pb-[70px] relative`}
            >
              <div className="w-full lg:w-[678px]">
                <h1 className="text-custom_h4 sm:text-custom_h3 md:text-custom_h2 2xl:text-custom_h1 text-heading_color dark:text-color_v1_dark mb-3">
                  {translate("be_the_first_to")}
                  <br className="hidden sm:block" />
                  <span>{translate("experience")}</span>
                  &nbsp;
                  <span className="text-main_color relative">
                    {translate("bil_bio")}
                  </span>
                </h1>

                <p className="text-body_copy_medium_color dark:text-color_v2_dark md:text-body_copy1_b xsmm:text-small2_b">
                  {translate("waitlist_early_access")}
                </p>
                <div className="mt-10 w-full sm:w-[480px] md:w-[560px] 2xl:w-[600px]">
                  <form onSubmit={handleSubmit((data) => SubmitHandler(data))}>
                    <div
                      className={`rounded-full p-2 bg-white ${
                        darkMode ? "" : "shadow-box_shadow_1"
                      } flex justify-between w-full sm:w-[480px] md:w-[560px] 2xl:w-[600px] items-center border border-[#f6f1eb] ${
                        errors?.email ? inputErrorClasses : inputNoErrorClasses
                      }`}
                    >
                      <div className="w-3/4">
                        <div className="flex items-center pl-[10px] sm:pl-[20px] px-1 sm:px-2 w-full ">
                          <input
                            type="email"
                            id="email"
                            autocomplete="off"
                            {...register("email", {
                              required: translate(
                                "descriptions.email_required"
                              ),
                              validate: {
                                maxLength: (v) =>
                                  v.length <= 50 ||
                                  translate(
                                    "front_end_pages.contact.the_email_should_have_less_then_characters"
                                  ),
                                matchPattern: (v) =>
                                  /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/.test(
                                    v
                                  ) || translate("descriptions.valid_email"),
                              },
                            })}
                            className={`${inputClasses} ${
                              errors?.email
                                ? inputErrorClasses
                                : inputNoErrorClasses
                            } placeholder:dark:text-font_light_color focus:placeholder:dark:text-heading_color`}
                            placeholder={translate(
                              "front_end_pages.contact.enter_email"
                            )}
                          />
                        </div>
                      </div>
                      <button
                        type="submit"
                        className="rounded-full whitespace-nowrap  xsmm:px-8 xsmm:pt-[9px] xsmm:pb-[8px]  xl:px-10 xl:py-3.5 text-white bg-main_color text-small2_b sm:text-small1_bold md:text-body_copy2_black lg:text-small1_bold xl:text-body_copy2_b"
                      >
                        {translate("submit")}
                      </button>
                    </div>
                    {errors?.email && (
                      <small className="text-state_color_error text-small3 mx-4 sm:ml-4">
                        {errors?.email?.message}
                      </small>
                    )}
                  </form>
                  <p
                    className="mx-2 font-normal mt-2 text-xs sm:text-sm tracking-[-0.2px] not-italic"
                    style={{ color: darkMode ? "#D5D5D5" : "#737373" }}
                  >
                    {translate("report.site_protected")}
                    <span className="font-bold text-main_color text-xs sm:text-sm tracking-[-0.2px] mx-1 not-italic">
                      {translate("privacy_policy")}
                    </span>
                    {translate("add")}
                    <span className="font-bold text-main_color text-xs sm:text-sm tracking-[-0.2px] mx-1 not-italic">
                      {translate("footer.terms_conditions")}
                    </span>
                    {translate("report.apply")}.
                  </p>
                </div>
              </div>
              <div className="w-full lg:w-[40%] flex justify-center xl:justify-end relative">
                <div className="relative">
                  <img
                    src={WaitingUserPageImage}
                    className="xsmm:max-h-[24rem] max-h-[21rem] sm:max-h-[38rem] lg:max-h-[32rem] xl:max-h-[35rem] 2xl:max-h-[38rem] z-20"
                    alt="..."
                    title="..."
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default WaitingListUSer;
